<template>
  <div>
    <Table  ref="selection" :columns="columns12" :data="OrderinfoLists" max-height="600">
        <!-- <template slot-scope="{ row, index }"  slot="material_icon">
            <Avatar size="large" :src="MaterialinfoLists[index].material_icon" style="background-color: #87d068"/>
        </template> -->
        <template slot-scope="{ row, index }" slot="action">
            <!-- <Button :size="buttonSize" type="text" style="margin-right: 5px" @click="show(index)">编辑</Button> -->
            <a href="#" @click.prevent="HandleClick(index)" v-if="OrderinfoLists[index].isAssign === '' && OrderinfoLists[index].State !== '全额已确认'">
              办理
            </a>
            <a href="#" @click.prevent="HandleClick(index)" v-if="OrderinfoLists[index].isAssign === '' && OrderinfoLists[index].State === '全额已确认'">
              重做
            </a>
            <a href="#" @click.prevent="AssignHandleClick(index)" v-if="OrderinfoLists[index].isAssign === '未分配'" style="color:red">
              分配
            </a>
            <Divider type="vertical"/>
            <a href="#" @click.prevent="SeeHandleClick(index)">
              查看
            </a>
        </template>
    </Table>
  </div>
</template>

<script>
export default {
  name: 'OrderHomeTable',
  props: {
    OrderinfoLists: Array
  },
  data () {
    return {
      columns12: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '订单号',
          key: 'OrderID'
        },
        {
          title: '订单状态',
          key: 'State'
        },
        {
          title: '客户名称',
          key: 'Customer_Name'
        },
        {
          title: '下单时间',
          key: 'StartTime'
        },
        {
          title: '销售员',
          key: 'SalespersonName'
        },
        {
          title: '分配状态',
          key: 'isAssign'
        },
        {
          title: '操作',
          slot: 'action',
          width: 150,
          align: 'center'
        }
      ]
    }
  },
  methods: {
    // 点击办理按钮回调
    HandleClick (index) {
      const OrderID = this.OrderinfoLists[index].OrderID
      const CustomerName = this.OrderinfoLists[index].Customer_Name
      this.$emit('HandleClick', OrderID, CustomerName, '办理')
    },
    SeeHandleClick (index) {
      const OrderID = this.OrderinfoLists[index].OrderID
      const CustomerName = this.OrderinfoLists[index].Customer_Name
      this.$emit('HandleClick', OrderID, CustomerName, '查看')
    },
    // 点击分配按钮回调
    AssignHandleClick (index) {
      const openid = this.OrderinfoLists[index].openid
      this.$router.push({ name: 'Home_CustomerList', query: { openid: openid } })
    }
  }
}
</script>
